import { createContext } from "react";

/**
 * Feature Context
 * Provides feature access info to the entire app
 */
export const FeatureContext = createContext(null);

export default FeatureContext;
